export function formatPastedUrl(text) {
    const value = (text || '').trim();
    if (!value) return value;

    if (/^[a-z][a-z0-9+.-]*:\/\//i.test(value) || /^(mailto|tel):/i.test(value)) {
        return value;
    }

    // Protocol-relative //host -> https://host
    if (value.startsWith('//')) {
        return `https:${value}`;
    }

    return `https://${value}`;
}

// External links (other host, or mailto/tel) open in a new tab, matching legacy Quill's target="_blank".
export function externalLinkAttributes(url) {
    if (/^(mailto|tel):/i.test(url || '')) {
        return { target: '_blank', rel: 'noopener noreferrer' };
    }
    try {
        const parsed = new URL(url, window.location.href);
        if (parsed.hostname && parsed.hostname !== window.location.hostname) {
            return { target: '_blank', rel: 'noopener noreferrer' };
        }
    }
    catch (e) {
    }
    return { target: null, rel: null };
}

export function isDataUrl(value) {
    return /^\s*data:/i.test(value || '');
}

export function isValidLinkUrl(value) {
    const url = formatPastedUrl(value);
    if (!url) return false;

    if (/^(mailto|tel):.+/i.test(url)) return true;

    try {
        const parsed = new URL(url);
        return !!parsed.hostname && parsed.hostname.includes('.');
    }
    catch (e) {
        return false;
    }
}
